<template>
  <div class="company-setting">
    <v-tabs
      vertical
      active-class="custom-tab-active"
      v-model="settingTab"
      background-color="transparent"
      color="cyan"
      class="tab-border-right"
    >
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll setting-tabs-height"
        style="height: calc(100vh - 75px); position: relative"
      >
        <template v-for="(tab, index) in SettingTabs">
          <v-tab
            v-if="getPermission(tab.permission + ':view')"
            :key="index"
            :disabled="tab.disabled"
            class="font-size-16 font-weight-600 px-8"
            :href="'#' + tab.key"
          >
            {{ tab.title }}
          </v-tab>
        </template>
      </perfect-scrollbar>
      <v-tabs-items v-model="settingTab">
        <template v-for="(tab, index) in SettingTabs">
          <v-tab-item
            v-if="getPermission(tab.permission + ':view')"
            :value="tab.key"
            :key="index"
          >
            <component :is="tab.template" />
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import EntityTemplate from "@/view/pages/profile/Setting/Entity";
import CompanyTemplate from "@/view/pages/profile/Setting/Company";
import RolePermissionTemplate from "@/view/pages/profile/Setting/RolePermission";
import BrandingTemplate from "@/view/pages/profile/Setting/Branding";
// import CustomerTemplate from "@/view/pages/profile/Setting/Customer";
/* import SlotsTemplate from "@/view/pages/profile/Setting/Time-Slotes"; */
// import Note from "@/view/pages/profile/Setting/Note";
import EngineerTemplate from "@/view/pages/profile/Setting/Engineer";
// import QuotationNote from "@/view/pages/profile/Setting/QuotationNotes";
import QuotationInvoiceTemplate from "@/view/pages/profile/Setting/Quotation-Invoice";
import TermsAndConditionTemplate from "@/view/pages/profile/Setting/Terms-Condition";
import InvoiceTemplate from "@/view/pages/profile/Setting/Invoice";
import CalendarTemplate from "@/view/pages/profile/Setting/Calendar";
import CalendarSettingTemplate from "@/view/pages/profile/Setting/Calendar-Setting";
import EmailTemplate from "@/view/pages/profile/Setting/EmailTemplate";
import ServiceTemplate from "@/view/pages/profile/Setting/Service";
import Siklls from "@/view/pages/profile/Setting/Siklls-Cert-Lice";
import TagsList from "@/view/pages/profile/Setting/Tags-List";
import CustomerSetting from "@/view/pages/profile/Setting/Customer-Setting.vue";
import SupplierSetting from "@/view/pages/profile/Setting/Supplier-Setting.vue";
import LeaveTypeSetting from "@/view/pages/profile/Setting/LeaveType-Setting.vue";
import VisitTemplate from "@/view/pages/profile/Setting/Visit";
/* import CustomerReview from "@/view/pages/profile/Setting/Customer-Review"; */
// import ZoneTemplate from "@/view/pages/profile/Setting/ZoneTemplate";
import ZoneManagement from "@/view/pages/profile/Setting/ZoneManagement";
import PropertyTemplate from "@/view/pages/profile/Setting/Property";
/* import DeliveryTemplate from "@/view/pages/profile/Setting/Delivery"; */
/* import PickupTemplate from "@/view/pages/profile/Setting/Pickup"; */
/* import ModuleSetting from "@/view/pages/profile/Setting/Module-Setting.vue"; */
// import CustomFieldListing from "@/view/pages/custom-field-v2/CustomFieldListing.vue";
/* import TermsAndCondition from "@/view/pages/profile/Setting/TermsAndCondition"; */
/* import CountryList from "@/view/pages/profile/Setting/CountryList"; */
/* import QuotationTemplate from "@/view/pages/profile/Setting/Quotation"; */
/*


import PaymentTemplate from "@/view/pages/profile/Setting/Payment"; */
// import ProductTemplate from "@/view/pages/profile/Setting/Product";
// import PartTemplate from "@/view/pages/profile/Setting/Part";
import ToolTemplate from "@/view/pages/profile/Setting/Tool";
// import OwnAssetTemplate from "@/view/pages/profile/Setting/OwnAsset";
// import CustomerAssetTemplate from "@/view/pages/profile/Setting/CustomerAsset";
// import ServiceTemplate from "@/view/pages/profile/Setting/Service";
/* import IncidentTemplate from "@/view/pages/profile/Setting/Incident"; */

//import IntegrationTemplate from "@/view/pages/profile/Setting/Integrate";

/* import ScheduleTemplate from "@/view/pages/profile/Setting/schedule.vue"; */
// import LineItemTemplate from "@/view/pages/profile/Setting/LineItem";
/* import LeaveBarcodeTemplate from "@/view/pages/profile/Setting/Leave-barcode"; */
// import ServiceFormTemplate from "@/view/pages/profile/Setting/ServiceForm";
/* import LeaveTemplate from "@/view/pages/profile/Setting/leave.vue"; */

export default {
  name: "profile-setting",
  data() {
    return {
      SettingTabs: [
        {
          disabled: false,
          key: "entity",
          template: EntityTemplate,
          title: "Entity",
          permission: "setting",
        },
        {
          disabled: false,
          key: "company",
          template: CompanyTemplate,
          title: "Company",
          permission: "setting",
        },
        {
          disabled: false,
          key: "role-permission",
          template: RolePermissionTemplate,
          title: "Role & Permission",
          permission: "setting",
        },
        {
          disabled: false,
          key: "customer-setting",
          template: CustomerSetting,
          title: "Customer",
          permission: "setting",
        },
        {
          disabled: false,
          key: "supplier-setting",
          template: SupplierSetting,
          title: "Supplier",
          permission: "setting",
        },
        {
          disabled: false,
          key: "property",
          template: PropertyTemplate,
          title: "Site Location",
          permission: "setting",
        },
        {
          disabled: false,
          key: "quotation-invoice",
          template: QuotationInvoiceTemplate,
          title: "Quotation",
          permission: "setting",
        },
        {
          disabled: false,
          key: "terms-condition",
          template: TermsAndConditionTemplate,
          title: "Terms & Conditions",
          permission: "setting",
        },
        {
          disabled: false,
          key: "invoice",
          template: InvoiceTemplate,
          title: "Invoice",
          permission: "setting",
        },
        {
          disabled: false,
          key: "engineer",
          template: EngineerTemplate,
          title: "Technicians",
          permission: "setting",
        },
        // {
        //   disabled: false,
        //   key: "part",
        //   template: PartTemplate,
        //   title: "Part",
        //   permission: "setting",
        // },
        // {
        //   disabled: false,
        //   key: "product",
        //   template: ProductTemplate,
        //   title: "Product",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "product-service",
          template: ServiceTemplate,
          title: "Products / Services",
          permission: "setting",
        },
        // {
        //   disabled: false,
        //   key: "quotation-notes",
        //   template: QuotationNote,
        //   title: "Quotation",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "equipment",
          template: ToolTemplate,
          title: "Asset",
          permission: "setting",
        },
        // {
        //   disabled: false,
        //   key: "asset-equipment",
        //   template: OwnAssetTemplate,
        //   title: "Own Asset",
        //   permission: "setting",
        // },
        // {
        //   disabled: false,
        //   key: "client-equipment",
        //   template: CustomerAssetTemplate,
        //   title: "Customer Asset",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "siklls",
          template: Siklls,
          title: "Skill & Cert & Lice",
          permission: "setting",
        },
        // {
        //   disabled: false,
        //   key: "zones",
        //   template: ZoneTemplate,
        //   title: "Zone Territories",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "zone",
          template: ZoneManagement,
          title: "Zone Management",
          permission: "setting",
        },
        {
          disabled: false,
          key: "visit",
          template: VisitTemplate,
          title: "Visit",
          permission: "setting",
        },
        /*   {
          disabled: false,
          key: "customer-review",
          template: CustomerReview,
          title: "Customer Review",
          permission: "setting",
        }, */
        // {
        //   disabled: false,
        //   key: "customer",
        //   template: CustomerTemplate,
        //   title: "SERIAL NUMBERS",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "branding",
          template: BrandingTemplate,
          title: "Branding",
          permission: "setting",
        },

        /*    {
          disabled: false,
          key: "slotes",
          template: SlotsTemplate,
          title: "Delivery Time Slotes",
          permission: "setting",
        }, */
        /*   */
        /*{
          disabled: false,
          key: "lineitem",
          template: LineItemTemplate,
          title: "Line Item",
          permission: "setting",
        },*/
        /* {
          disabled: false,
          key: "quotation",
          template: QuotationTemplate,
          title: "Quotation",
          permission: "setting",
        }, */

        /*  {
          disabled: false,
          key: "payment",
          template: PaymentTemplate,
          title: "Payment",
          permission: "setting",
        }, */
        /*  {
          disabled: false,
          key: "engineer",
          template: EngineerTemplate,
          title: "Technicians",
          permission: "setting",
        }, */

        // {
        //   disabled: false,
        //   key: "service",
        //   template: ServiceTemplate,
        //   title: "Service",
        //   permission: "setting",
        // },

        /* {
          disabled: false,
          key: "delivery",
          template: DeliveryTemplate,
          title: "Delivery",
          permission: "setting",
        }, */
        /*  {
          disabled: false,
          key: "pickup",
          template: PickupTemplate,
          title: "Pickup Address",
          permission: "setting",
        }, */
        {
          disabled: false,
          key: "calendar",
          template: CalendarTemplate,
          title: "Holiday",
          permission: "setting",
        },
        {
          disabled: false,
          key: "calendar-setting",
          template: CalendarSettingTemplate,
          title: "Calendar Setting",
          permission: "setting",
        },
        {
          disabled: false,
          key: "leave-type-setting",
          template: LeaveTypeSetting,
          title: "Leave Type Setting",
          permission: "setting",
        },
        {
          disabled: false,
          key: "email-template",
          template: EmailTemplate,
          title: "Email Template",
          permission: "setting",
        },
        // {
        //   disabled: false,
        //   key: "notes",
        //   template: Note,
        //   title: "Autocomplete",
        //   permission: "setting",
        // },
        // {
        //   disabled: false,
        //   key: "custom-field",
        //   template: CustomFieldListing,
        //   title: "Custom Fields",
        //   permission: "setting",
        // },
        {
          disabled: false,
          key: "tag",
          template: TagsList,
          title: "Tags",
          permission: "setting",
        },
        /*    {
          disabled: false,
          key: "module-settings",
          template: ModuleSetting,
          title: "Module Setting",
          permission: "setting",
        }, */
        /* {
          disabled: false,
          key: "integration",
          template: IntegrationTemplate,
          title: "Integrations",
          permission: "dashboard",
        },*/
        /*   {
          disabled: false,
          key: "leave-setting",
          template: LeaveTemplate,
          title: "Leave Setting",
          permission: "dashboard",
        }, */

        /*  {
          disabled: false,
          key: "terms-and-conditions",
          template: TermsAndCondition,
          title: "Terms & Conditions",
          permission: "setting",
        }, */
        /*  {
          disabled: false,
          key: "phone-country-code",
          template: CountryList,
          title: "Country List",
          permission: "setting",
        }, */
      ],
    };
  },
  watch: {
    settingTab(param) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(param) },
      ]);
    },
  },
  methods: {
    getTitle(key) {
      const selected = this.lodash.find(this.SettingTabs, { key });
      if (selected) {
        return selected.title;
      }
      return "";
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Profile" },
      { title: "Setting" },
    ]);

    if (this.$route.query && this.$route.query.tab) {
      this.settingTab = this.$route.query.tab;

      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(this.settingTab) },
      ]);
    }
  },
  computed: {
    settingTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.settingTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "entity";
      },
    },
  },
};
</script>
